// extracted by mini-css-extract-plugin
module.exports = {"composer":"styles-m__composer---3TVlL"};